export default "__VITE_ASSET__Dh7kux_r__"